export default [{
	titulo: 'Multimídias',
	icone: 'menu-icon fa fa-caret-right',
	url: '/site/multimidias',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]